<template>
  <div>
    <h1 class="display-1 font-weight-bold mx-1 mb-3">Boards</h1>
    <v-row>
      <v-col cols="6" v-for="board in boards" :key="board.id">
        <v-card outlined class="mb-2">
          <v-card-title>
            <router-link :to="'board/' + board.id">{{ board.name }}</router-link>
          </v-card-title>
          <v-card-text>
            {{ board.desc }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  async created() {},
  methods: {},

  computed: {
    ...mapGetters({
      boards: "trello/boards",
    }),
  },
  watch: {},
};
</script>
